import React from 'react';
import classNames from 'classnames';

import { IsMobile } from '../../../helpers/IsMobile';

import styles from './CustomTextField.module.scss';

const CustomTextField = ({
  label,
  CustomIcon,
  className,
  onIconClick,
  inputRef,
  error,
  reverseIcon = false,
  disableFloatingLabel = false,
  placeholder = '',
  isJobLocationSearch,
  ...inputProps
}) => {
  const { value, defaultValue } = inputProps;

  const isMobile = IsMobile();
  return (
    <div className={styles.container}>
      <span className="blocking-span">
        <input
          className={classNames(
            styles.inputText,
            error ? styles.error : '',
            reverseIcon && styles.inputTextPadding,
            !isMobile && disableFloatingLabel && reverseIcon && styles.inputTextLocation,
            !isMobile && isJobLocationSearch && styles.inputTextLocation,
            isMobile && styles.inputFilterBorder,
            className
          )}
          data-type={disableFloatingLabel ? 'location' : ''}
          ref={inputRef}
          {...inputProps}
          placeholder={placeholder}
        />
        {!disableFloatingLabel && (
          <span className={classNames(value || defaultValue ? styles.floatingLabelFocused : styles.floatingLabel)}>
            {label}
          </span>
        )}
        {CustomIcon && (
          <button
            style={{ cursor: `${onIconClick ? 'pointer' : 'auto'}` }}
            type="button"
            className={classNames(styles.floatingLabelIcon, reverseIcon && styles.floatingLabelIconLeft)}
            onClick={onIconClick}
          >
            <CustomIcon />
          </button>
        )}
      </span>
    </div>
  );
};

export default CustomTextField;
